package com.narbase.letsgo.web.models.pushpayload

import com.narbase.letsgo.dto.EnumDtoName

enum class PushDeliveryPriority(dtoName: String? = null) : EnumDtoName {
    IMMEDIATE,
    CONSERVE_POWER
    ;

    override val dtoName = dtoName ?: this.name
}

enum class PushDeliveryType(dtoName: String? = null) : EnumDtoName {
    ALERT,
    BACKGROUND
    ;

    override val dtoName = dtoName ?: this.name
}
